// ABOUTME: Session storage as a convenience, never as a fact: reads and writes that swallow a private window's refusal
// ABOUTME: or blocked site data, so a screen falls back to its default instead of failing.
export const readSession = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeSession = (key: string, value: string): void => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // The value is not kept; the default applies on the next visit.
  }
};

/** A stored JSON value, or the fallback when there is none or it does not parse. */
export const readSessionJson = <T>(key: string, fallback: T): T => {
  const raw = readSession(key);
  if (raw === null) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
};

export const writeSessionJson = (key: string, value: unknown): void =>
  writeSession(key, JSON.stringify(value));
